import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import {
  CustomAccordion,
  Title,
} from "../styles/CommonQuestionsStyles";
import type {
  AccordionChangeHandler,
  CommonQuestion,
} from "./commonQuestionsTypes";

type CommonQuestionAccordionProps = {
  item: CommonQuestion;
  expanded: string | false;
  handleChange: AccordionChangeHandler;
};

export const CommonQuestionAccordion = ({
  item,
  expanded,
  handleChange,
}: CommonQuestionAccordionProps) => {
  const panelId = `panel${item.id}`;
  const headerId = `${panelId}bh-header`;
  const contentId = `${panelId}bh-content`;
  const isExpanded = expanded === panelId;

  return (
    <CustomAccordion
      expanded={isExpanded}
      onChange={handleChange(panelId, item.question)}
    >
      <AccordionSummary
        expandIcon={isExpanded ? <RemoveIcon /> : <AddIcon />}
        aria-controls={contentId}
        id={headerId}
      >
        <Title variant="h6" $isexpanded={isExpanded}>
          {item.question}
        </Title>
      </AccordionSummary>

      <AccordionDetails id={contentId} aria-labelledby={headerId}>
        <Typography component="p" sx={{ whiteSpace: "pre-wrap" }}>
          {item.answer}
        </Typography>
      </AccordionDetails>
    </CustomAccordion>
  );
};
